<template>
  <collapse v-model="activeNames" style="width: 100%">
    <collapse-item :key="purchaseOrderId" name="supply-pro-project" class="col-md-12 card">
      <template slot="title">
        <div class="collapse-item-header" style="width: 100%;">
          <div class="col-md-6" v-if="!activeNames.length > 0" style="margin-top: 20px;">Project</div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-md-6" v-if="activeNames.length">
              <i class="nc-icon nc-ruler-pencil inline-block" style="padding-right: 10px;" v-if="newProject"></i>
              <img class="inline-block" style="padding-right: 10px;" src="static/img/icon-checkmark.png" v-if="!newProject"/>
              <label class="inline-block" style="color: royalblue;">{{ projectFound }}</label>
            </div>
            <div class="col-md-6" v-if="possibleMatchingProjects.length > 0 && activeNames.length > 0">
              <label><Strong><h5 style="font-size: 20.5px">Select Project</h5></Strong></label>
              <el-select class="select m-left-10"
                         name="projectMatches"
                         fit-input-width="true"
                         style="min-width: 300px"
                         ref="projectsSelect"
                         placeholder="Matching projects"
                         v-model="selectedProjectIndex"
                         @change="updatePtracProjectFields">
                <el-option class="select"
                           :value="'new'"
                           :label="'Create New Project'"
                           :key="'new'">
                </el-option>
                <el-option v-for="(option, index) in possibleMatchingProjects"
                           class="select"
                           :value="index"
                           :label="option.name"
                           :key="option.label">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </template>

      <div style="margin-top: 20px;">
        <div class="row">
          <div class="col-md-4"><label><Strong><h5>Purchase Order Project Data</h5></Strong></label></div>
          <div class="col-md-8"><label><Strong><h5>PTRAC Project Fields</h5></Strong></label></div>
        </div>

        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <strong style="display: block">Project Name</strong>
            <div class="inline-block">
              <el-input type="text"
                        name="name"
                        style="min-width: 300px; padding-right: 10px;"
                        v-validate="modelValidations.name"
                        v-model="ptracProject.name"
                        maxlength="256"
                        placeholder="Project Name"
                        clearable
                        @blur="validateNameIsUnique"/>
            </div>
            <button @click="generateProjectName" class="btn btn-fill btn-info btn-sm btn-save tiny-label-button inline-block" style="margin: 0;"> + </button>
            <small class="text-danger" style="display: block" v-show="errors.has('name')">
              {{ getError('name') }}
            </small>
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <strong style="display: block">Type</strong>
            <el-select class="select"
                       name="projectType"
                       clearable
                       size="large"
                       placeholder="Types"
                       v-validate="modelValidations.projectType"
                       data-vv-as="type"
                       v-model="ptracProject.projectType">
              <el-option v-for="option in projectTypes"
                         class="select"
                         :value="option.value"
                         :label="option.label"
                         :key="option.label">
              </el-option>
            </el-select>
            <small class="text-danger" style="display: block" v-show="errors.has('projectType')">
              {{ getError('projectType') }}
            </small>
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <strong style="display: block">Departments</strong>
            <el-select multiple class="select"
                       name="departments"
                       size="large"
                       clearable
                       @change="populateJobDepartment"
                       ref="departmentsSelect"
                       placeholder="Departments"
                       v-validate="modelValidations.departments"
                       v-model="ptracProject.departments">
              <el-option v-for="option in sortedDepartments"
                         class="select"
                         :value="option.value"
                         :label="option.label"
                         :key="option.label">
              </el-option>
            </el-select>
            <small class="text-danger" style="display: block" v-show="errors.has('departments')">
              {{ getError('departments') }}
            </small>
            <div>
              <small class="text-danger" v-show="!surveyOrInspectionSelected">Must include Survey or Inspections</small>
            </div>
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4 sp-align-fields">
            <div v-if="poProjectData.city" style="width: 100%">
              <strong class="inline-block">City: </strong>
              <div class="sp-value inline-block"> {{ poProjectData.city }} </div>
              <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.PROJECT_FIELDS.CITY)">
                <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.PROJECT_FIELDS.CITY)"/>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <strong style="display: block">City</strong>
            <el-autocomplete
                name="city"
                ref="city"
                class="inline-input"
                size="large"
                clearable
                :disabled="!canEdit"
                v-model="localCity"
                :fetch-suggestions="findCities"
                :trigger-on-focus="false"
                value-key="name"
                placeholder="City"
                @blur="verifyCityAutocompleteSelected"
                @select="setCityLoadCountiesZips">
            </el-autocomplete>
            <small class="text-danger" style="display: block" v-show="showInvalidAutocompleteWarning('city')">
              {{ fieldNotValidError('City') }}
            </small>
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4 sp-align-fields">
            <div v-if="poProjectData.street" style="width: 100%">
              <strong class="inline-block">Street: </strong>
              <div class="sp-value inline-block"> {{ poProjectData.street }} </div>
              <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.PROJECT_FIELDS.STREET)">
                <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.PROJECT_FIELDS.STREET)"/>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <strong style="display: block">Street Number</strong>
            <el-input type="text"
                      name="streetNumber"
                      placeholder="Street Number"
                      style="max-width: 204px"
                      clearable
                      :disabled="!canEdit"
                      v-validate="modelValidations.streetNumber"
                      v-model="ptracProject.address.streetNumber" />
            <small class="text-danger" style="display: block" v-show="errors.has('streetNumber')">
              {{ getError('streetNumber') }}
            </small>
          </div>
          <div class="col-md-5">
            <strong style="display: block">Street Name</strong>
            <el-autocomplete
                ref="streetName"
                name="streetName"
                size="large"
                class="inline-input"
                clearable
                :disabled="!canEdit"
                v-model="localStreetName"
                v-validate="modelValidations.streetName"
                :fetch-suggestions="findStreets"
                :trigger-on-focus="false"
                value-key="name"
                placeholder="Street Name"
                @focus="verifyCitySelected"
                @blur="verifyStreetNameAutocompleteSelected"
                @select="setStreet">
            </el-autocomplete>
            <small class="text-danger" style="display: block" v-show="showInvalidAutocompleteWarning('streetName')">
              {{ fieldNotValidError('Street Name') }}
            </small>
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <strong style="display: block">County</strong>
            <el-select class="select"
                       name="county"
                       size="large"
                       clearable
                       :disabled="!canEdit"
                       placeholder="County"
                       @focus="verifyCitySelected"
                       v-validate="modelValidations.county"
                       v-model="ptracProject.address.county">
              <el-option v-for="option in counties"
                         class="select"
                         :value="option.value"
                         :label="option.label"
                         :key="option.label">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="line"></div>

        <div class="row" v-if="poProjectData.stateCode">
          <div class="col-md-4 sp-align-fields">
            <div v-if="poProjectData.stateCode" style="width: 100%">
              <strong class="inline-block">State Code: </strong>
              <div class="sp-value inline-block"> {{ poProjectData.stateCode }} </div>
              <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.PROJECT_FIELDS.STATE)">
                <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.PROJECT_FIELDS.STATE)"/>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <strong style="display: block">State</strong>
            <el-select class="select"
                       size="large"
                       name="state"
                       clearable
                       :disabled="!canEdit"
                       v-model="ptracProject.address.state">
              <el-option v-for="option in states"
                         class="select"
                         :value="option.value"
                         :label="option.label"
                         :key="option.label">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4 sp-align-fields">
            <div v-if="poProjectData.streetSupplement">
              <strong class="inline-block">Street Supplement: </strong> <div class="sp-value inline-block"> {{ poProjectData.streetSupplement }} </div>
            </div>
          </div>
          <div class="col-md-8">
            <strong style="display: block">Building Number</strong>
            <el-input type="text"
                      name="buildingNumber"
                      placeholder="Building Number"
                      style="max-width: 204px"
                      clearable
                      :disabled="!canEdit"
                      v-validate="modelValidations.buildingNumber"
                      v-model="ptracProject.address.buildingNumber" />
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <strong style="display: block">Floor Number</strong>
            <el-input type="text"
                      name="floorNumber"
                      placeholder="Floor Number"
                      style="max-width: 204px"
                      clearable
                      :disabled="!canEdit"
                      v-validate="modelValidations.floorNumber"
                      v-model="ptracProject.address.floorNumber" />
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <strong style="display: block">Suite Number</strong>
            <el-input type="text"
                      name="suiteNumber"
                      placeholder="Suite Number"
                      style="max-width: 204px"
                      clearable
                      :disabled="!canEdit"
                      v-validate="modelValidations.suiteNumber"
                      v-model="ptracProject.address.suiteNumber" />
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4 sp-align-fields">
            <div v-if="poProjectData.postalCode" style="width: 100%">
              <strong class="inline-block">Postal Code: </strong>
              <div class="sp-value inline-block"> {{ poProjectData.postalCode }} </div>
              <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.PROJECT_FIELDS.ZIP_CODE)">
                <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.PROJECT_FIELDS.ZIP_CODE)"/>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <strong style="display: block">Zip</strong>
            <el-select class="select"
                       name="zip"
                       size="large"
                       clearable
                       :disabled="!canEdit"
                       placeholder="Zip"
                       @focus="verifyCitySelected"
                       v-model="ptracProject.address.zip">
              <el-option v-for="option in zipCodes"
                         class="select"
                         :value="option.value"
                         :label="option.label"
                         :key="option.label">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <strong style="display: block">Jurisdiction</strong>
            <el-select class="select"
                       name="jurisdiction"
                       size="large"
                       clearable
                       :disabled="!canEdit"
                       placeholder="Jurisdiction"
                       v-validate="modelValidations.jurisdiction"
                       v-model="ptracProject.address.jurisdiction">
              <el-option v-for="option in constants.JURISDICTIONS"
                         class="select"
                         :value="option.value"
                         :label="option.label"
                         :key="option.label">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4 sp-align-fields">
            <div v-if="poProjectData.lot" style="width: 100%">
              <strong class="inline-block">Lot: </strong>
              <div class="sp-value inline-block"> {{ poProjectData.lot }} </div>
              <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.PROJECT_FIELDS.LOT)">
                <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.PROJECT_FIELDS.LOT)"/>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <strong style="display: block">Lot Number</strong>
            <el-input type="text"
                      name="lotNumber"
                      placeholder="Lot Number"
                      style="max-width: 204px"
                      clearable
                      :disabled="!canEdit"
                      v-model="ptracProject.address.lotNumber" />
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4 sp-align-fields">
            <div v-if="poProjectData.block" style="width: 100%">
              <strong class="inline-block">Block: </strong>
              <div class="sp-value inline-block"> {{ poProjectData.block }} </div>
              <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.PROJECT_FIELDS.BLOCK)">
                <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.PROJECT_FIELDS.BLOCK)"/>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <strong style="display: block">Block Number</strong>
            <el-input type="text"
                      name="blockNumber"
                      placeholder="Block Number"
                      style="max-width: 204px"
                      clearable
                      :disabled="!canEdit"
                      v-model="ptracProject.address.blockNumber" />
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4 sp-align-fields">
            <div v-if="poProjectData.phase" style="width: 100%">
              <strong class="inline-block">Phase: </strong>
              <div class="sp-value inline-block"> {{ poProjectData.phase }} </div>
              <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.PROJECT_FIELDS.PHASE)">
                <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.PROJECT_FIELDS.PHASE)"/>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <strong style="display: block">Phase</strong>
            <el-input type="text"
                      name="phase"
                      placeholder="Phase"
                      style="max-width: 204px"
                      clearable
                      :disabled="!canEdit"
                      v-model="ptracProject.address.phase" />
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <strong style="display: block">Section</strong>
            <el-input type="text"
                      name="section"
                      placeholder="Section"
                      style="max-width: 204px"
                      clearable
                      :disabled="!canEdit"
                      v-validate="modelValidations.section"
                      v-model="ptracProject.address.section" />
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <strong style="display: block">Legal Description</strong>
            <el-input type="text"
                      name="legalDescription"
                      placeholder="Legal Description"
                      style="max-width: 204px"
                      clearable
                      :disabled="!canEdit"
                      v-validate="modelValidations.legalDescription"
                      v-model="ptracProject.address.legalDescription" />
          </div>
        </div>

        <div class="line"></div>

        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <strong style="display: block">Legal Subdivision</strong>
            <el-autocomplete
                ref="legalSubdivisionId"
                name="legalSubdivision"
                class="inline-input"
                size="large"
                clearable
                :disabled="!canEdit"
                data-vv-name="legal subdivision"
                v-model="localLegalSubdivisionName"
                v-validate="modelValidations.legalSubdivisionId"
                :fetch-suggestions="findLegalSubdivisions"
                :trigger-on-focus="false"
                value-key="name"
                placeholder="Legal Subdivision"
                @blur="verifyLegalSubdivisionAutocompleteSelected"
                @select="setLegalSubdivision">
            </el-autocomplete>
            <small class="text-danger" style="display: block" v-show="showInvalidAutocompleteWarning('legalSubdivisionId')">
              {{ fieldNotValidError('Legal Subdivision') }}
            </small>
          </div>
        </div>

        <div style="width: 100%;">
          <div class="pull-right" style="margin-top: 20px">
            <p-button wide v-if="!newProject && !projectChanged" :disabled="isSubmitDisabled" @click="confirmProject" class="btn btn-fill btn-info btn-wd">Confirm Project</p-button>
            <p-button wide v-if="!newProject && projectChanged" :disabled="isSubmitDisabled" @click="updateProject" class="btn btn-fill btn-info btn-wd">Update Project</p-button>
            <p-button wide v-if="newProject" :disabled="isSubmitDisabled" @click="createProject" class="btn btn-fill btn-info btn-wd">Create New Project</p-button>
          </div>
        </div>
      </div>
    </collapse-item>
  </collapse>
</template>

<script>
import {mapGetters} from 'vuex'
import {sync} from 'vuex-pathify'
import {
  kvpsForSelectFromArray,
  notifySuccess,
  notifyError,
  verifyAutocompleteSelected,
  notifyWarning,
  findCities,
  setCityLoadCountiesZips,
  findStreets,
  findLegalSubdivisions,
  autocompleteTextButNoValue,
  autocompleteTextButNoValueMessage,
  maybeGenerateProjectName
} from '@/utilities/utils'
import {OK} from 'http-status-codes'
import Constants from '@/utilities/constants'
import _ from 'lodash'
import {ObjectID} from 'bson'
import {Collapse, CollapseItem} from 'element-ui'

export default {
  components: {
    Collapse,
    CollapseItem
  },
  props: ['purchaseOrderId'],
  computed: {
    poProjectData: sync('supplyPro/project@poProjectData'),
    ptracProject: sync('supplyPro/project@ptracProject'),
    surveyOrInspectionSelected: sync('supplyPro/project/surveyOrInspectionSelected'),
    ...mapGetters({
      activeModals: 'modalTracker/activeModals',
      matchingProject: 'supplyPro/project/matchingProject',
      possibleMatchingProjects: 'supplyPro/project/possibleMatchingProjects',
      sortedDepartments: 'departments/kvpsForSelectNoIt',
      projectTypes: 'types/project',
      states: 'states',
      cities: 'address/cities',
      user: 'security/user'
    }),
    projectFound() {
      if (this.possibleMatchingProjects.length > 0) {
        return "1 or more possible project matches found. Please select a Project."
      } else if (this.matchingProjectFound) {
        return "Matching Project found. Working from existing Project."
      } else {
        return "No Matching Project found. Creating new PTRAC Project"
      }
    },
    matchingProjectFound() {
      return (Object.keys(this.matchingProject).length > 0)
    },
    newProject() {
      return !(this.$store.get('supplyPro/project/ptracProject@id'))
    },
    canEdit() {
      const jobs = this.projectJobsForPermissions
      if (!this.newProject && this.$store.get('security/isInGroup', Constants.GROUPS.POWER_USERS)
        && ((jobs.length === 1 && jobs[0].status === Constants.STATUSES.COMPLETED) || jobs.length > 1)) {
        // If Job >1 in Project, or if there is one Job only and Completed, restrict changing the Project Address to Admin and Super Users only.
        return false
      }
      // all admin and super users can edit OR no jobs have been complete d in this project
      return true
    },
    isSubmitDisabled() {
      return this.isProcessing
    }
  },
  data() {
    return {
      activeNames: 'supply-pro-project',
      constants: Constants,
      isProcessing: false,
      projectChanged: false,
      projectJobsForPermissions: [],
      selectedProjectIndex: 0,
      localCity: null,
      localStreetName: null,
      localLegalSubdivisionName: null,
      counties: [],
      zipCodes: [],
      modelValidations: {
        name: {
          required: true,
          max: 150
        },
        departments: {
          required: true
        },
        projectType: {
          required: true // BUG: this doesn't work with el-select, set default value in mounted() as a workaround
        },
        streetNumber: {
          max: 16
        }
      }
    }
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    showInvalidAutocompleteWarning(refAndPathName) {
      // $ref has to match prop in store
      return autocompleteTextButNoValue(this, refAndPathName, this.$store.get(`supplyPro/project/ptracProject@address.${refAndPathName}`))
    },
    fieldNotValidError(field) {
      return autocompleteTextButNoValueMessage(field)
    },
    async pushField(field) {
      if (!this.canEdit) {
        notifyWarning(this, 'Permission denied. Power Users cannot edit address fields on existing projects.')
        return
      }

      const poProject = this.$store.get('supplyPro/project/poProjectData')
      switch (field) {
        case Constants.SUPPLYPRO.PROJECT_FIELDS.CITY:{
          const response = await this.$store.dispatch('cities/fetchByName', poProject.city)
          if (OK === response.status) {
            this.setCityLoadCountiesZips(response.data)
            return
          }
          this.$eventHub.$emit('show-modal-6', 'No City Results Found', poProject.city, '500px')
          break
        }
        case Constants.SUPPLYPRO.PROJECT_FIELDS.STREET: {
          this.verifyCitySelected()
          const formattedPoStreet = this.$store.get('supplyPro/project/formattedPoStreet')
          if (formattedPoStreet.number && this.localCity) {
            this.$store.set('supplyPro/project/ptracProject@address.streetNumber', formattedPoStreet.number)
          }
          if (formattedPoStreet.name && this.localCity) {
            const response = await this.$store.dispatch('streets/fetchFindByCity', this.localCity)
            if (OK === response.status && response.data.find(({ name }) => name === formattedPoStreet.name)) {
              this.setStreet(formattedPoStreet)
              return
            } // If street doesn't exist or isn't associated with localCity, open modal
            const streetPayload = {
              id: new ObjectID(),
              name: formattedPoStreet.name,
              cities: [this.localCity],
              active: true
            }
            this.$eventHub.$emit('show-modal-6', 'Street Results', streetPayload, '500px')
          }
          break
        }
        case Constants.SUPPLYPRO.PROJECT_FIELDS.STATE:
          if (this.states.find(({ value }) => value === poProject.stateCode.substring(2))) {
            this.$store.set('supplyPro/project/ptracProject@address.state', poProject.stateCode.substring(2))
            return
          }
          notifyWarning(this, 'Unable to populate State. Please select from drop-down.')
          break
        case Constants.SUPPLYPRO.PROJECT_FIELDS.ZIP_CODE:
          if (this.zipCodes.find(({ label }) => label === poProject.postalCode)) {
            this.$store.set('supplyPro/project/ptracProject@address.zip', poProject.postalCode)
            return
          }
          notifyWarning(this, 'Unable to populate Zip Code. Check city or select from drop-down.')
          break
        case Constants.SUPPLYPRO.PROJECT_FIELDS.LOT:
          this.$store.set('supplyPro/project/ptracProject@address.lotNumber', poProject.lot)
          break
        case Constants.SUPPLYPRO.PROJECT_FIELDS.BLOCK:
          this.$store.set('supplyPro/project/ptracProject@address.blockNumber', poProject.block)
          break
        case Constants.SUPPLYPRO.PROJECT_FIELDS.PHASE:
          this.$store.set('supplyPro/project/ptracProject@address.phase', poProject.phase)
      }
    },
    fieldsMatch(field) {
      const poProject = this.$store.get('supplyPro/project/poProjectData')
      const ptracAddress = this.$store.get('supplyPro/project/ptracProject@address')
      if (field === Constants.SUPPLYPRO.PROJECT_FIELDS.CITY && poProject.city) {
        return poProject.city === ptracAddress.city || (!poProject.city && !ptracAddress.city)
      }
      if (field === Constants.SUPPLYPRO.PROJECT_FIELDS.STREET && poProject.street) { // Needs testing(Missing #, name, in poProject and ptrac
        const formattedPoStreet = this.$store.get('supplyPro/project/formattedPoStreet')
        return (formattedPoStreet.name === ptracAddress.streetName || (!formattedPoStreet.name && !ptracAddress.streetName)) && (formattedPoStreet.number === ptracAddress.streetNumber || (!formattedPoStreet.number && !ptracAddress.streetNumber))
      }
      if (field === Constants.SUPPLYPRO.PROJECT_FIELDS.STATE && poProject.stateCode) {
        return poProject.stateCode.substring(2) === ptracAddress.state || (!poProject.stateCode && !ptracAddress.state)
      }
      if (field === Constants.SUPPLYPRO.PROJECT_FIELDS.ZIP_CODE && poProject.postalCode) {
        return poProject.postalCode === ptracAddress.zip || (!poProject.postalCode && !ptracAddress.zip)
      }
      if (field === Constants.SUPPLYPRO.PROJECT_FIELDS.LOT && poProject.lot) {
        return poProject.lot === ptracAddress.lotNumber || (!poProject.lot && !ptracAddress.lotNumber)
      }
      if (field === Constants.SUPPLYPRO.PROJECT_FIELDS.BLOCK && poProject.block) {
        return poProject.block === ptracAddress.blockNumber || (!poProject.block && !ptracAddress.blockNumber)
      }
      if (field === Constants.SUPPLYPRO.PROJECT_FIELDS.PHASE && poProject.phase) {
        return poProject.phase === ptracAddress.phase || (!poProject.phase && !ptracAddress.phase)
      }
    },
    async validateNameIsUnique() {
      const response = await this.$store.dispatch(
        'projects/fetchExistsByName',
        this.$store.get('supplyPro/project/ptracProject@name')
      )
      if (OK === response.status && response.data) {
        notifyError(this, 'Project names must be unique. Please enter a different project name.')
      }
    },
    async findCities(text, cb) {
      findCities(this, text, cb, 'supplyPro/project/ptracProject@address.city')
    },
    verifyCityAutocompleteSelected() {
      if (this.localCity !== this.$store.get('supplyPro/project/ptracProject@address.city')) {
        verifyAutocompleteSelected(this, 'supplyPro/project/ptracProject@address.city', Constants.SUPPLYPRO.PROJECT_FIELDS.CITY, this.localCity)
        this.resetDependentAutocompleteFields()
      }
    },
    setCityLoadCountiesZips(city) {
      setCityLoadCountiesZips(this, city, 'supplyPro/project/ptracProject@address.city')
    },
    clearCity() {
      this.localCity = null
    },
    resetDependentAutocompleteFields() {
      this.counties = []
      this.zipCodes = []
      this.localStreetName = null
      this.$store.set('address/cities', [])
      this.$store.set('supplyPro/project/ptracProject@address.city', null)
      this.$store.set('supplyPro/project/ptracProject@address.streetName', null)
      this.$store.set('supplyPro/project/ptracProject@address.county', null)
      this.$store.set('supplyPro/project/ptracProject@address.zip', null)
    },
    verifyCitySelected() {
      if (!this.localCity || !this.$store.get('supplyPro/project/ptracProject@address.city')) {
        this.$eventHub.$emit('show-modal-6', 'No City Error', null, '500px')
      }
    },
    verifyStreetNameAutocompleteSelected() {
      verifyAutocompleteSelected(this, 'supplyPro/project/ptracProject@address.streetName', 'street name', this.localStreetName)
    },
    setStreet(street) {
      this.localStreetName = street.name
      this.$store.set('supplyPro/project/ptracProject@address.streetName', street.name)
    },
    clearStreet() {
      this.localStreetName = null
    },
    async findStreets(text, cb) {
      findStreets(this, text, cb, 'supplyPro/project/ptracProject@address.')
    },
    generateProjectName() {
      maybeGenerateProjectName(this, 'supplyPro/project/ptracProject')
    },
    async checkForExistingProj(selectedProjectIndex) {
      if (this.matchingProjectFound || this.possibleMatchingProjects.length > 0) {
        await this.$store.dispatch('supplyPro/project/populateFieldsFromExistingProject', selectedProjectIndex)
        await this.$store.set(
          'supplyPro/job/ptracJob@projectId',
          this.$store.get('supplyPro/project/ptracProject@id')
        )
        await this.populateJobDepartment()
        await this.fetchJobCountForPermissions()
        return
      }
      await this.$store.dispatch('supplyPro/project/populateFieldsForCreateProject')
    },
    async findLegalSubdivisions(text, cb) {
      findLegalSubdivisions(this, text, cb, 'supplyPro/project/ptracProject@address.')
    },
    verifyLegalSubdivisionAutocompleteSelected() {
      verifyAutocompleteSelected(this, 'supplyPro/project/ptracProject@address.legalSubdivisionId', 'legal subdivision', this.localLegalSubdivisionName)
    },
    setLegalSubdivision(legalSubdivision) {
      this.localLegalSubdivisionName = legalSubdivision.name
      this.$store.set('supplyPro/project/ptracProject@address.legalSubdivisionId', legalSubdivision.id)
    },
    clearLegalSubdivision() {
      this.localLegalSubdivisionName = null
    },
    projectSet() {
      this.$store.set('supplyPro/project/projectSet', true)
      this.activeNames = []
      this.$emit('scrollToJob')
    },
    async populateJobDepartment() {
      await this.$store.dispatch('supplyPro/job/populateDepartmentFromProject')
    },
    async updatePtracProjectFields(selectedProjectIndex) {
      if (selectedProjectIndex === 'new') {
        await this.$store.dispatch('supplyPro/project/populateFieldsForCreateProject')
        await this.maybeSetDefaultDepartment()
        return
      }
      await this.checkForExistingProj(selectedProjectIndex)
    },
    async maybeSetDefaultDepartment() {
      if (_.get(this.user, 'preferences.global.defaultDepartment') && this.newProject) {
        this.$store.set('supplyPro/project/addDepartment', this.user.preferences.global.defaultDepartment)
        await this.populateJobDepartment()
      }
    },
    async maybeSetLocalCityStreetLegalSubdivision() {
      if (this.$store.get('supplyPro/project/ptracProject@address.city')) {
        this.localCity = this.$store.get('supplyPro/project/ptracProject@address.city')
        if (this.localCity) {
          const response = await this.$store.dispatch('cities/fetchByName', this.localCity)
          if (OK === response.status) {
            const city = response.data
            this.counties = kvpsForSelectFromArray(city.counties)
            this.zipCodes = kvpsForSelectFromArray(city.zipCodes)
          }
        }
      }
      if (this.$store.get('supplyPro/project/ptracProject@address.streetName')) {
        this.localStreetName = this.$store.get('supplyPro/project/ptracProject@address.streetName')
      }
      const lsid = this.$store.get('supplyPro/project/ptracProject@address.legalSubdivisionId')
      if (lsid) {
        const response = await this.$store.dispatch('fetchById', { endpoint: 'legal-subdivisions', id: lsid })
        if (OK === response.status) {
          this.localLegalSubdivisionName = response.data.name
        }
      }
    },
    async fetchJobCountForPermissions() {
      if (this.$store.get('supplyPro/project/ptracProject@id')) {
        const response = await this.$store.dispatch('jobs/fetchByProjectId', this.$store.get('supplyPro/project/ptracProject@id'))
        if (OK === response.status ) {
          this.projectJobsForPermissions = response.data
        }
      }
    },
    resetState() {
      this.$store.set('supplyPro/project/surveyOrInspectionSelected', false)
      this.projectChanged = false
      this.zipCodes = []
      this.localCity = null
      this.localStreetName = null
      this.localLegalSubdivisionName = null
    },
    async createProject() {
      this.isProcessing = true

      if (await this.$validator.validateAll()) {
        const response = await this.$store.dispatch('supplyPro/project/createProject')
        if (OK === response.status ) {
          this.$store.set(
            'supplyPro/job/ptracJob@projectId',
            this.$store.get('supplyPro/project/ptracProject@id')
          )
          notifySuccess(this, 'Project Created Successfully')
          this.projectSet()
          return
        }
        notifyError(this, 'Failed to Create Project')
      }
      this.isProcessing = false
    },
    async updateProject() {
      this.isProcessing = true

      if (await this.$validator.validateAll()) {
        if (!this.matchingProjectFound) {
          const response = await this.$store.dispatch('supplyPro/project/confirmProject')
          if (OK !== response.status) {
            notifyError(this, 'Failed to Match Project to Purchase Order')
            return
          }
        }
        const response = await this.$store.dispatch('supplyPro/project/updateProject')
        if (OK === response.status) {
          notifySuccess(this, "Project Updated Successfully")
          this.projectChanged = false
          this.projectSet()
        }
      }
      this.isProcessing = false
    },
    async confirmProject() {
      this.isProcessing = true

      if (await this.$validator.validateAll()) {
        if (!this.matchingProjectFound) {
          const response = await this.$store.dispatch('supplyPro/project/confirmProject')
          if (OK !== response.status) {
            notifyError(this, 'Failed to match Project to Purchase Order')
            return
          }
        }
        notifySuccess(this, 'Project Confirmed')
        this.projectSet()
      }
      this.isProcessing = false
    }
  },
  async created() {
    await this.$store.dispatch('supplyPro/project/getPoProjectData')
    await this.$store.dispatch('supplyPro/project/findMatchingProjects')
    await this.checkForExistingProj()
    await this.maybeSetDefaultDepartment()
    await this.maybeSetLocalCityStreetLegalSubdivision()
  },
  async mounted() { //Be careful. Mounted seems to be getting called before created()
    this.$eventHub.$on('citySaved', this.setCityLoadCountiesZips)
    this.$eventHub.$on('noCitySaved', this.clearCity)
    this.$eventHub.$on('streetSaved', this.setStreet)
    this.$eventHub.$on('noStreetSaved', this.clearStreet)
    this.$eventHub.$on('legalSubdivisionSaved', this.setLegalSubdivision)
    this.$eventHub.$on('noLegalSubdivisionSaved', this.clearLegalSubdivision)
  },
  destroyed() {
    this.$eventHub.$off('citySaved')
    this.$eventHub.$off('noCitySaved')
    this.$eventHub.$off('streetSaved')
    this.$eventHub.$off('noStreetSaved')
    this.$eventHub.$off('legalSubdivisionSaved')
    this.$eventHub.$off('noLegalSubdivisionSaved')
    this.resetState()
  },
  watch: {
    ptracProject: {
      handler: function(ptracProject) {
        let selectedProject
        if (this.matchingProjectFound) {
          selectedProject = this.matchingProject
        } else {
          selectedProject = this.possibleMatchingProjects[this.selectedProjectIndex]
        }

        if (!selectedProject) {
          return
        }

        for (const key in ptracProject.address) {
          if (JSON.stringify(ptracProject.address[key]) === JSON.stringify(selectedProject.address[key]) || (ptracProject.address[key] == null && selectedProject.address[key] == null)) {
            this.projectChanged = false
          } else {
            this.projectChanged = true
            return
          }
        }

        for (const key in ptracProject) {
          if (key !== 'address') {
            if (JSON.stringify(ptracProject[key]) === JSON.stringify(selectedProject[key]) || (ptracProject[key] == null && selectedProject[key] == null)) {
              this.projectChanged = false
            } else {
              this.projectChanged = true
              return
            }
          }
        }
      },
      deep: true
    },
    projectChanged: {
      handler: function(projectChanged) {
        if (projectChanged) {
          notifyWarning(this, 'Editing Existing Project')
          if (this.$store.get('supplyPro/project/projectSet')) {
            this.$store.set('supplyPro/project/projectSet', false)
          }
        }
        if (!projectChanged) {
          notifyWarning(this, 'Working From Existing Project')
        }
      }
    },
    localCity: {
      handler: function(city) {
        if (!city) {
          this.resetDependentAutocompleteFields()
        }
      }
    },
    localStreetName: {
      handler: function(streetName) {
        if (!streetName) {
          this.$store.set('projects/create/edit@address.streetName', null)
        }
      }
    },
    localLegalSubdivisionName: {
      handler: function(localLegalSubdivisionName) {
        if (!localLegalSubdivisionName) {
          this.$store.set('projects/edit/address/legalSubdivisionId', null)
        }
      }
    }
  }
}
</script>

<style scoped>
  .m-left-10 {
    margin-left: 10px;
  }
  .sp-align-fields {
    display: flex;
    align-items: center;
  }
  .line {
    margin-top: 7px;
    padding-bottom: 4px;
    border-top: 1px solid rgba(0,0,0,.1);
  }
  .push-button {
    display: inline-block;
    float: right;
  }
  .sp-value {
    margin-left: 5px;
    font-size: 14px;
    color: #606266;
  }
</style>
